export default "__VITE_ASSET__DsRcg79x__"